import { createSlice } from '@reduxjs/toolkit';

interface AuthState {
    isLoading: boolean;
    isAuthenticated: boolean;
    user: any | null;
}

const initialState: AuthState = {
    isLoading: true,
    isAuthenticated: false,
    user: null,
};

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {},
});

export default authSlice.reducer;
